import React from 'react'

import SchoolFootprintLabel from './schoolFootprints/Label'
import WarrantsLabel from './warrants/Label'
import MissingPersonLabel from './missingPerson/Label'
import Hangup911Label from './hangups/Label'
import PoliceAVLLabel from './policeAVLs/Label'
import HydrantLabel from './hydrants/Label'
import DefaultAILabel from './DefaultAILabel'

import styles from './AIListItemLabel.module.css'

const AIListItemLabel = props => {
  const { ai } = props

  return <div className={styles.aiLabel}>{AIToLabel(ai)}</div>
}

function AIToLabel(ai) {
  switch (ai.layerId) {
    case 20:
      return <SchoolFootprintLabel ai={ai} />
    case 19:
      return <WarrantsLabel ai={ai} />
    case 18:
      return <MissingPersonLabel ai={ai} />
    case 17:
      return <Hangup911Label ai={ai} />
    case 15:
      return <PoliceAVLLabel ai={ai} />
    case 14:
      return <HydrantLabel ai={ai} />
    default:
      return <DefaultAILabel ai={ai} />
  }
}

export default AIListItemLabel
